export const zhTW = {
  translation: {
    header: {
      title: "你好",
      tips_one: "頁面已被瀏覽{{count}}次",
      tips_other: "頁面已被瀏覽{{count}}次",
      tips_zero: "暫無瀏覽",
    },
    date: "今天是{{date, DATE_HUGE}}",
  },
};
